import * as React from "react";
const Navopen = (props) => (
  <svg
    width={32}
    height={31}
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.6668 9.04102C27.6668 9.57604 27.2191 10.0098 26.6668 10.0098H5.3335C4.78122 10.0098 4.3335 9.57604 4.3335 9.04102C4.3335 8.50599 4.78122 8.07227 5.3335 8.07227H26.6668C27.2191 8.07227 27.6668 8.50599 27.6668 9.04102Z"
      fill="#000000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.6668 15.5C27.6668 16.035 27.2191 16.4688 26.6668 16.4688H5.3335C4.78122 16.4688 4.3335 16.035 4.3335 15.5C4.3335 14.965 4.78122 14.5312 5.3335 14.5312H26.6668C27.2191 14.5312 27.6668 14.965 27.6668 15.5Z"
      fill="#000000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.6668 21.959C27.6668 22.494 27.2191 22.9277 26.6668 22.9277H5.3335C4.78122 22.9277 4.3335 22.494 4.3335 21.959C4.3335 21.424 4.78122 20.9902 5.3335 20.9902H26.6668C27.2191 20.9902 27.6668 21.424 27.6668 21.959Z"
      fill="#000000"
    />
  </svg>
);
export default Navopen;
